import { doStartOrder, doSubmitOrder } from '../../orders/dispatchers'
import { Reward } from '../types'
import { getIsSteppedUp } from '../../auth/selectors'

export const doDonationLinkRedemptionFlow = (reward: Reward) => async (dispatch, getState) => {
  await dispatch(doStartOrder(reward.rewardId, reward.rewardParentId, reward.content))
  await dispatch(doSubmitOrder(getState().orders.inProgress, getIsSteppedUp(getState())))
}
